import {
  cloneElement,
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const AppCustomModalWrapper = forwardRef(({ children }, ref) => {
  const [isFirstOpenModal, setIsFirstOpenModal] = useState(false);
  const childrenModalRef = useRef();
  const openModal = useCallback(() => {
    if (!isFirstOpenModal) setIsFirstOpenModal(true);
    else childrenModalRef.current?.openModal();
  }, [isFirstOpenModal]);
  useImperativeHandle(
    ref,
    () => ({
      openModal,
      closeModal: childrenModalRef.current?.closeModal,
    }),
    [openModal]
  );
  useEffect(() => {
    if (isFirstOpenModal) childrenModalRef.current?.openModal();
  }, [isFirstOpenModal]);
  return (
    isFirstOpenModal &&
    cloneElement(children, { ...children.props, ref: childrenModalRef })
  );
});

export default AppCustomModalWrapper;
